<template>
    <!--弹窗-->
    <el-dialog
        width="80%"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form ref="formData" :model="formData" :rules="rules" :inline="true" size="mini">
            <div class="subTitle">基础信息</div>
            <div class="top1">
                <div class="top1Left">
                    <el-form-item label="">
                        <img style="width:90px;height:90px;" :src="diffVal('img_url').value"
                             v-if="diffVal('img_url').value"/>
                    </el-form-item>
                </div>
                <div class="top1Right">
                    <div class="itemInfo">
                        <div class="itemTitle">ASIN:</div>
                        <div class="itemContent">
                            <icon-svg :icon-class="diffVal('state').value.toUpperCase()" v-if="diffVal('state').value"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                            {{ diffVal('asin').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">评分:</div>

                        <div class="itemContent">{{ diffVal('rating').value }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">类目:</div>
                        <div style="width: 230px; display: flex; overflow:hidden;">
                            <div class="itemContent" @click="showInfo('类目', diffVal('category').value)">{{
                                    diffVal('category').value
                                }}
                            </div>
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">销售国家:</div>
                        <div class="itemContent" v-if="diffVal('category_state').value">
                            <icon-svg :icon-class="diffVal('category_state').value.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">评论数:</div>
                        <div class="itemContent">{{ diffVal('rating_count').value }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">类目树:</div>
                        <div class="itemContent" @click="showInfo('类目树', diffVal('category_tree').value)">
                            {{ diffVal('category_tree').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">父ASIN:</div>
                        <div class="itemContent">{{ diffVal('parent_asin').value }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">fba费用:</div>
                        <div class="itemContent">{{ diffVal('fba_fees').value }}</div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">子类目:</div>
                        <div class="itemContent" @click="showInfo('子类目', diffVal('categories_str').value)">
                            {{ diffVal('categories_str').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">品牌:</div>
                        <div class="itemContent" @click="showInfo('品牌', diffVal('brand').value)">{{
                                diffVal('brand').value
                            }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">上架时间:</div>
                        <div class="itemContent">{{ diffVal('listed_since').value }}</div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="subTitle">调整参数</div>
            <div class="top2">
                <div class="line1">
                    <div class="itemInfo">
                        <div class="itemTitle">标题:</div>
                        <div style="width: 420px; display: flex; overflow:hidden;">
                            <div class="itemContent" @click="showInfo('标题', diffVal('title').value)">{{
                                    diffVal('title').value
                                }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="line2">
                    <div class="itemInfo">
                        <div class="itemTitle">销售价格:</div>
                        <div class="itemContent">{{ formData.selling_price }}</div>
                        <div class="diffVal" v-show="diffVal('selling_price').flag">
                            =>{{ diffVal('selling_price').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">退货率:</div>
                        <div class="itemContent">{{ parseFloat((formData.refund_rate || 0) * 100).toFixed(2) }}%</div>
                        <div class="diffVal" v-show="diffVal('refund_rate').flag">
                            =>{{ parseFloat((diffVal('refund_rate').value || 0) * 100).toFixed(2) }}%
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">是否季节性:</div>
                        <div class="itemContent">{{ formData.is_seasonality == 1 ? '是' : '否' }}</div>
                        <div class="diffVal" v-show="diffVal('is_seasonality').flag">
                            =>{{ diffVal('is_seasonality').value == 1 ? '是' : '否' }}
                        </div>
                    </div>
                </div>
                <div class="line3">
                    <div class="itemTit">规格:</div>
                    <div class="itemInfo">
                        <div class="itemTitle">长(cm):</div>
                        <div class="itemContent">{{ formData.long }}</div>
                        <div class="diffVal" v-show="diffVal('long').flag">
                            =>{{ diffVal('long').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">宽(cm):</div>
                        <div class="itemContent">{{ formData.wide }}</div>
                        <div class="diffVal" v-show="diffVal('wide').flag">
                            =>{{ diffVal('wide').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">高(cm):</div>
                        <div class="itemContent">{{ formData.height }}</div>
                        <div class="diffVal" v-show="diffVal('height').flag">
                            =>{{ diffVal('height').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">重(g):</div>
                        <div class="itemContent">{{ formData.weight }}</div>
                        <div class="diffVal" v-show="diffVal('weight').flag">
                            =>{{ diffVal('weight').value }}
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="subTitle">1688产品</div>
            <div class="top3">
                <div class="top3Left">
                    <div v-if="!formData.ali_pic_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="formData.ali_pic_url" v-if="formData.ali_pic_url"/>
                </div>
                <div class="top3Right">
                    <div class="itemInfo">
                        <div class="itemTitle">图片路径:</div>
                        <div style="display: flex;width: 230px;">
                            <div class="itemContent" @click="showInfo('图片路径', formData.ali_pic_url)">
                                {{ formData.ali_pic_url }}
                            </div>
                            <div class="diffVal itemContent" v-show="diffVal('ali_pic_url').flag"
                                 @click="showInfo('新图片路径',diffVal('ali_pic_url').value)">
                                =>{{ diffVal('ali_pic_url').value }}
                            </div>
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">标题:</div>
                        <div style="display: flex;width: 230px;">
                            <div class="itemContent" @click="showInfo('标题', formData.ali_title)">{{
                                    formData.ali_title
                                }}
                            </div>
                            <div class="diffVal itemContent" v-show="diffVal('ali_title').flag"
                                 @click="showInfo('新标题', diffVal('ali_title').value)">
                                =>{{ diffVal('ali_title').value }}
                            </div>
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">产品价格:</div>
                        <div class="itemContent">{{ formData.ali_factory_price }}</div>
                        <div class="diffVal" v-show="diffVal('ali_factory_price').flag">
                            =>{{ diffVal('ali_factory_price').value }}
                        </div>
                    </div>
                    <div class="itemInfo" style="width: 700px">
                        <div class="itemTitle">产品链接:</div>
                        <div style="width: 460px; display: flex;flex-wrap: nowrap">
                            <div class="itemContent" @click="showInfo('产品链接', formData.ali_href_link)">
                                {{ formData.ali_href_link }}
                            </div>
                            <el-button v-show="formData.ali_href_link" type="primary" size="mini"
                                       @click="jumpUrl(formData.ali_href_link)">跳转
                            </el-button>
                            <div class="diffVal itemContent" v-if="diffVal('ali_href_link').flag"
                                 style="min-width: 100px"
                                 @click="showInfo('新产品链接', diffVal('ali_href_link').value )">
                                =>{{ diffVal('ali_href_link').value }}
                            </div>
                            <el-button v-show="diffVal('ali_href_link').flag " type="primary" size="mini"
                                       @click="jumpUrl(diffVal('ali_href_link').value )">跳转
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="subTitle">成本结算</div>
            <div class="top4">
                <div class="line1">
                    <div class="itemInfo">
                        <div class="itemTitle">运输模式:</div>
                        <div class="itemContent">{{ formData.deliver_mode }}</div>
                        <div class="diffVal" v-show="diffVal('deliver_mode').flag">
                            =>{{ diffVal('deliver_mode').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">运费:</div>
                        <div class="itemContent">{{ formData.freight }}</div>
                        <div class="diffVal" v-show="diffVal('freight').flag">
                            =>{{ diffVal('freight').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">运费单价/kg:</div>
                        <div class="itemContent">{{ formData.freight_unit_price }}</div>
                        <div class="diffVal" v-show="diffVal('freight_unit_price').flag">
                            =>{{ diffVal('freight_unit_price').value }}
                        </div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">运费差:</div>
                        <div class="itemContent">{{ formData.freight_difference }}</div>
                        <div class="diffVal" v-show="diffVal('freight_difference').flag">
                            =>{{ diffVal('freight_difference').value }}
                        </div>
                    </div>

                </div>
                <div class="line2">
                    <div class="itemInfo">
                        <div class="itemTitle">平台佣金:</div>
                        <div class="itemContent">{{ formData.platform_commission }}</div>
                        <div class="diffVal" v-show="diffVal('platform_commission').flag">
                            =>{{ diffVal('platform_commission').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">亚马逊物流配送费:</div>
                        <div class="itemContent">{{ formData.delivery_charge }}</div>
                        <div class="diffVal" v-show="diffVal('delivery_charge').flag">
                            =>{{ diffVal('delivery_charge').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">退货费用:</div>
                        <div class="itemContent">{{ formData.refund_charge }}</div>
                        <div class="diffVal" v-show="diffVal('refund_charge').flag">
                            =>{{ diffVal('refund_charge').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">Vat税费:</div>
                        <div class="itemContent">{{ formData.vat_charge }}</div>
                        <div class="diffVal" v-show="diffVal('vat_charge').flag">
                            =>{{ diffVal('vat_charge').value }}
                        </div>
                    </div>
                </div>
                <div class="line3">
                    <div class="itemInfo">
                        <div class="itemTitle">美国旺季差额:</div>
                        <div class="itemContent">{{ formData.us_peak_season_balance }}</div>
                        <div class="diffVal" v-show="diffVal('us_peak_season_balance').flag">
                            =>{{ diffVal('us_peak_season_balance').value }}
                        </div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">0利润销售价格:</div>
                        <div class="itemContent">{{ formData.seller_price_no_profit }}</div>
                        <div class="diffVal" v-show="diffVal('seller_price_no_profit').flag">
                            =>{{ diffVal('seller_price_no_profit').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">0利润销售价格(免税):</div>
                        <div class="itemContent">{{ formData.seller_price_no_profit_no_tax }}</div>
                        <div class="diffVal" v-show="diffVal('seller_price_no_profit_no_tax').flag">
                            =>{{ diffVal('seller_price_no_profit_no_tax').value }}
                        </div>
                    </div>
                </div>
                <div class="line4">
                    <div class="itemInfo">
                        <div class="itemTitle">1-9月仓储费:</div>
                        <div class="itemContent">{{ formData.early_storage_charge }}</div>
                        <div class="diffVal" v-show="diffVal('early_storage_charge').flag">
                            =>{{ diffVal('early_storage_charge').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">1-9月利润:</div>
                        <div class="itemContent">{{ formData.early_profit }}</div>
                        <div class="diffVal" v-show="diffVal('early_profit').flag">
                            =>{{ diffVal('early_profit').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">1-9月利润(免税):</div>
                        <div class="itemContent">{{ formData.early_profit_no_tax }}</div>
                        <div class="diffVal" v-show="diffVal('early_profit_no_tax').flag">
                            =>{{ diffVal('early_profit_no_tax').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">1-9月投资回报率:</div>
                        <div class="itemContent">{{
                                formData['early_investment_return_rate'] ? (accMul(formData['early_investment_return_rate'], 100) + '%') : '-'
                            }}
                        </div>
                        <div class="diffVal" v-show="diffVal('ali_href_link').flag">
                            =>{{
                                diffVal('early_investment_return_rate').value ? (accMul(diffVal('early_investment_return_rate').value, 100) + '%') : '-'
                            }}
                        </div>
                    </div>
                </div>
                <div class="line4">
                    <div class="itemInfo">
                        <div class="itemTitle">10-12月仓储费:</div>
                        <div class="itemContent">{{ formData.late_storage_charge }}</div>
                        <div class="diffVal" v-show="diffVal('late_storage_charge').flag">
                            =>{{ diffVal('late_storage_charge').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">10-12月利润:</div>
                        <div class="itemContent">{{ formData.late_profit }}</div>
                        <div class="diffVal" v-show="diffVal('late_profit').flag">
                            =>{{ diffVal('late_profit').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">10-12月利润(免税):</div>
                        <div class="itemContent">{{ formData.late_profit_no_tax }}</div>
                        <div class="diffVal" v-show="diffVal('late_profit_no_tax').flag">
                            =>{{ diffVal('late_profit_no_tax').value }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">10-12月投资回报率:</div>
                        <div class="itemContent">{{
                                formData['late_investment_return_rate'] ? (accMul(formData['late_investment_return_rate'], 100) + '%') : '-'
                            }}
                        </div>
                        <div class="diffVal" v-show="diffVal('late_investment_return_rate').flag">
                            =>{{
                                diffVal('late_investment_return_rate').value ? (accMul(diffVal('late_investment_return_rate').value, 100) + '%') : '-'
                            }}
                        </div>
                    </div>
                </div>
            </div>
        </el-form>
        <!--        <categoryList :visible="showCategoryList" @choose1688Info="choose1688Info" :copyData="copyData"-->
        <!--                      @close-callback="showCategoryList=false"></categoryList>-->
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
            >关 闭
            </el-button>
        </el-row>
        <child-info-modal :visible="childInfoVisible" :info="previewInfo"
                          @close-callback="closeCllback"></child-info-modal>
    </el-dialog>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import categoryList from './categoryList'
import childInfoModal from './childInfoModal.vue'
import {cost_analysis_personal_update_field} from '@/api/advAnalys/advAnalys.js'

export default {
    components: {categoryList, childInfoModal},
    data() {
        return {
            loading: false,
            showCategoryList: false,
            options: [],
            copyData: {},
            title: '',
            visible: false,
            rules: {
                keepa_category_id: [
                    {
                        required: true,
                        message: '请选择根类目',
                        trigger: 'blur'
                    },
                ],
            },
            formData: {},
            previewInfo: {},
            childInfoVisible: false,
        }
    },
    watch: {
        copyData: {
            handler(val) {
                if (this.visible) {
                    const tempVal = JSON.parse(JSON.stringify(val))
                    tempVal.refund_rate = this.accMul(tempVal.refund_rate, 100)
                    tempVal.is_seasonality = tempVal.is_seasonality === 1 ? true : false
                    this.formData = tempVal
                }
            },
            immediate: true,
            deep: true
        },
    },

    methods: {
        diffVal(key) {
            return {
                flag: this.formData[key] !== this.formData.old_contents[key],
                value: this.formData.old_contents[key]
            }
        },
        // 关闭弹窗回调
        closeCllback(isShow) {
            this.childInfoVisible = false
            this.previewInfo = {}
            isShow == true && this.getList()
        },
        showInfo(title, info) {
            this.previewInfo = {title, info}
            this.childInfoVisible = true
        },
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        choose1688Info(data) {
            this.formData.ali_href_link = data.detail_url
            this.formData.ali_factory_price = data.price
            this.formData.ali_title = data.title
            this.formData.ali_pic_url = data.pic_url
            this.showCategoryList = false
        },
        choose1688() {
            this.showCategoryList = true
        },
        // 保存信息
        submitForm() {
            this.$refs['formData'].validate(valid => {
                if (valid) {
                    api.cost_analysis_personal_update_field({
                        id: this.formData.id,
                        wrappage: this.formData.wrappage,
                        wrappage_long: this.formData.wrappage_long,
                        wrappage_wide: this.formData.wrappage_wide,
                        wrappage_height: this.formData.wrappage_height,
                        wrappage_link: this.formData.wrappage_link,
                        purchase_specification_remark: this.formData.purchase_specification_remark,
                    }).then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            })
                            this.handleClose(true)
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(() => {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '网络出现问题，请刷新页面！'
                        })
                    })
                } else {
                    this.loading = false
                    this.$message({
                        type: 'error',
                        message: '请填写相应内容！'
                    })
                }
            })
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            // this.formData = {}
            this.visible = false
            this.$emit('close-callback', isshow)
        },
        // 重置
        handleReset(isshow = false) {
            api.cost_analysis_personal_reset({id: this.formData.id,}).then(res => {
                if (res.code === 0) {
                    this.$message({message: '重置成功', type: 'success'})

                    const tempVal = JSON.parse(JSON.stringify(res.data))
                    tempVal.refund_rate = this.accMul(tempVal.refund_rate, 100)
                    tempVal.is_seasonality = tempVal.is_seasonality === 1 ? true : false
                    this.$set(this, 'formData', tempVal)

                    this.$emit('refreshList')
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(() => {
                this.$message({
                    type: 'error',
                    message: '网络出现问题，请刷新页面！'
                })
            })
        },
        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },

        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },

        accDiv(arg1, arg2) {
            let t1, t2
            t1 = this.getDecimalLength(arg1)
            t2 = this.getDecimalLength(arg2)
            if (t1 - t2 > 0) {
                return (this.getNum(arg1) / this.getNum(arg2)) / Math.pow(10, t1 - t2)
            } else {
                return (this.getNum(arg1) / this.getNum(arg2)) * Math.pow(10, t2 - t1)
            }
        },

        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },

        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },

        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.diffVal {
    color: red;
}

.subTitle {
    font-size: 16px;
    font-weight: 900;
    margin: 20px 0;
}

.top1 {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .top1Right {
        display: flex;
        flex-wrap: wrap;
        width: 1200px;

        .itemInfo {
            width: 360px;
            display: flex;
            height: 28px;
            line-height: 28px;

            .itemTitle {
                font-size: 14px;
                color: #606266;
                padding: 0 12px 0 0;
                font-weight: 900;
            }

            .itemContent {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}

.top2 {
    .line1 {
        .itemInfo {
            width: 500px;
        }
    }

    .line2, .line3 {
        width: 1100px;
        display: flex;
        justify-content: space-between;

        .itemInfo {
            width: 330px;
        }


        .itemTit {
            min-width: 60px;
            height: 28px;
            line-height: 28px;
            font-size: 14px;
            color: #606266;
            padding: 0 12px 0 0;
            font-weight: 900;
        }
    }

    .itemInfo {
        display: flex;
        justify-content: start;
        height: 28px;
        line-height: 28px;

        .itemTitle {
            font-size: 14px;
            color: #606266;
            padding: 0 12px 0 0;
            font-weight: 900;
        }

        .itemContent {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}

.top3 {
    display: flex;
    justify-content: space-between;
    width: 600px;

    .top3Left {
        width: 100px;
        height: 120px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        button {
            margin-top: 10px;
        }
    }

    .top3Right {
        width: 400px;

        .itemInfo {
            width: 360px;
            display: flex;
            height: 28px;
            line-height: 28px;

            .itemTitle {
                font-size: 14px;
                color: #606266;
                padding: 0 12px 0 0;
                font-weight: 900;
            }

            .itemContent {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}

.top4 {
    .line1, .line2, .line4, .line3 {
        display: flex;
        justify-content: start;
    }

    .itemInfo {
        width: 25%;
        display: flex;
        height: 28px;
        line-height: 28px;
        margin-bottom: 10px;

        .itemTitle {
            font-size: 14px;
            color: #606266;
            padding: 0 12px 0 0;
            font-weight: 900;
        }

        .itemContent {
            max-width: 230px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .line4 {
        .line4Left, .line4Right {
            width: 50%;
        }

        .itemInfo {
            width: 100%;
        }
    }

}

.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;

    .shu {
        border-right: 1px solid #cecfd1;
    }

    .content-div {
        width: 50%;
        padding: 25px 20px;
    }

    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }

    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }

    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;

        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;

            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }

    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}

.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>
